<template>
	<div class="sampleAssignment">
		<PageHeader @back="goback" :content="'约访转让'" />
		<div class="sampleAssignmentBox">
			<div class="setBtn">
				<el-tooltip class="item" effect="light" content="请选择转让的访员与样本" placement="top">
					<!-- :disabled="ruleForm.userId != '' || userLaterSampleSelect.length == 0" -->
					<el-button  size="medium" type="primary" @click="dialogVisible = true">
						样本转让<span v-if="userLaterSampleSelect.length > 0">（{{ userLaterSampleSelect.length }}）</span>
					</el-button>
				</el-tooltip>
			</div>
			<div class="topTableBox">
				<div>
					<el-table class="topLeft" max-height="400" highlight-current-row border @selection-change="userLaterSampleChange" :data="userAppointmentSampleSumData">
						<!-- <el-table-column align="center" type="selection" width="40"></el-table-column> -->
						<el-table-column align="center" label="选择访员">
							<template slot-scope="scope">
								<span :class="userID == scope.row.userId ? 'checkedTrue' : 'checkedFalse'" @click="chooseInterviewer(scope.row)">
									{{ scope.row.userName }} ( {{ scope.row.count }}个 )
								</span>
							</template>
						</el-table-column>
					</el-table>
				</div>
				<div class="topRight">
					<el-table border :data="userLaterSampleDtat" @selection-change="userLaterSampleChange">
						<el-table-column type="selection" width="40" v-if="activeHide"></el-table-column>
						<el-table-column
							v-for="item in columnList"
							:key="item.enfieldName"
							align="center"
							:prop="item.enfieldName"
							:label="item.chfieldName"
							:fixed="item.fixed"
						></el-table-column>

						<el-table-column align="center" fixed="right" label="操作" width="120" v-if="activeHide">
							<template slot-scope="scope">
								<el-button @click.native.prevent="viewDetails(scope)" type="text">查看样本</el-button>
							</template>
						</el-table-column>
					</el-table>
					<div class="block">
						<el-pagination
							@size-change="handleSizeChange"
							@current-change="handleCurrentChange"
							:current-page="pagination.pageNo"
							:page-sizes="[10, 50, 100, 200, 300, 400]"
							:page-size="pagination.pageSize"
							layout="total, sizes, prev, pager, next, jumper"
							:total="pagination.total"
						></el-pagination>
					</div>
				</div>
			</div>
		</div>
		<!-- 选择样本要指派的专家 -->
		<el-dialog title="选择访员" :visible.sync="dialogVisible" width="500px" :close-on-click-modal="false">
			<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="70px" class="demo-ruleForm">
				<el-form-item label="访员：" prop="userId">
					<el-select  style="width: 100%;" size="medium" v-model="ruleForm.userId" placeholder="请选择">
						<el-option v-for="(item,index) in InterviewerSamleCountData" :key="index" :label="item.userName" :value="item.userId"></el-option>
					</el-select>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button size="medium" @click="cancel('ruleForm')">取消</el-button>
				<el-button size="medium"  type="primary" :loading="makeOverLoading" @click="confirmMakeOver('ruleForm')">确定</el-button>
			</span>
		</el-dialog>
		<!-- 查看详情 修改样本 -->
		<particulars ref="particulars" :fieldContrast="fieldContrast"></particulars>
	</div>
</template>

<script>
import particulars from './particulars';
import PageHeader from '@/components/pageHeader.vue';
export default {
	components: {
		particulars,
		PageHeader
	},
	data() {
		return {
			source:'',
			id: '',
			pagination: {
				pageNo: 1,
				total: 0,
				pageSize: 10
			},
			userLaterSampleSelect: [],
			userAppointmentSampleSumData: [],
			userID: '',
			userLaterSampleDtat: [],

			// 表头
			activeHide: false,
			columnList: [],
			// 查看样本
			fieldContrast: [],
			// 选择访员
			InterviewerSamleCountData:[],
			dialogVisible: false,
			ruleForm: {
				userId: ''
			},
			rules: {
				userId: [
					{ required: true, message: '请选择访员', trigger: 'change' }
				],
			},
			makeOverLoading: false
		};
	},
	created() {
		this.id = this.$route.query.id;
		this.source = this.$route.query.source;
		this.queryFieldConfig();
		this.queryUserAppointmentSampleSum(); //查询访员名字以及访员分配样本个数
		this.queryInterviewerSamleCount()
	},
	methods: {
		queryInterviewerSamleCount() {
			let data = {
				surveyId: this.id,
				source:this.source
			};
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.queryInterviewerSamleCount}`,
				method: 'POST',
				data: data,
				cb(res) {
					if (res.code == 0) {
						that.InterviewerSamleCountData = res.resultBody;
					} else {
						that.InterviewerSamleCountData = [];
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},
		confirmMakeOver(formName){
			this.$refs[formName].validate((valid) => {
				if (valid) {
					this.makeOverLoading = true
					let that = this;
					let params = {
						that: this,
						url: `${this.$config.service.transferUserAppointmentSample}`,
						method: 'POST',
						data: {
							qid: this.id,
							sampleCode:this.userLaterSampleSelect.toString(),
							userId: this.ruleForm.userId
						},
						cb(res) {
							if (res.code == 0) {
								console.log(res)
								that.queryUserAppointmentSampleSum(); //查询访员名字以及访员分配样本个数
								that.$message.success(res.message);
								that.dialogVisible = false;
							} else {
								that.$message.error(res.message);
							}
						},
						finally() {
							that.makeOverLoading = false
						}
					};
					this.$util.request(params);
				} else {
					console.log('error submit!!');
					return false;
				}
			});
		},
		// 查看样本/
		viewDetails(scope) {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.queryAllFieldName}`,
				method: 'POST',
				data: {
					qid: this.id
				},
				cb(res) {
					if (res.code == 0) {
						that.fieldContrast = res.resultBody.questionsFieldMappings;
						that.$refs.particulars.form = JSON.parse(JSON.stringify(scope.row));
						that.$refs.particulars.title = '查看详情';
						that.$refs.particulars.loadData();
					} else {
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},
		queryFieldConfig() {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.queryFieldConfig}`,
				method: 'POST',
				data: {
					qid: this.id,
					source:this.source
				},
				cb(res) {
					console.log('查询左中右', res);
					if (res.code == 0) {
						if (res.resultBody != '') {
							let leftList = JSON.parse(res.resultBody.leftFieldName);
							let centreList = JSON.parse(res.resultBody.centreFieldName);
							let rigthList = JSON.parse(res.resultBody.rightFieldName);
							leftList.forEach(item => {
								item.fixed = 'left';
							});
							rigthList.forEach(item => {
								item.fixed = 'rigth';
							});
							console.log(leftList, centreList, rigthList);

							let tempAllList = [...leftList, ...centreList, ...rigthList];
							that.activeHide = false;
							tempAllList.forEach((item, index) => {
								if (item.chfieldName == '操作') {
									tempAllList.splice(index, 1);
									that.activeHide = true;
								}
							});
							that.columnList = tempAllList;
						} else {
							that.columnList = [];
						}
					} else {
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},
		// 选择访员
		chooseInterviewer(scope) {
			console.log(scope.userId);
			this.userID = scope.userId;
			this.queryUserAppointmentSample(this.userID);
		},
		queryUserAppointmentSampleSum() {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.queryUserAppointmentSampleSum}`,
				method: 'POST',
				data: {
					qid: this.id,
					source:this.source
				},
				cb(res) {
					if (res.code == 0) {
						if (res.resultBody.length > 0) {
							that.userAppointmentSampleSumData = res.resultBody;
							console.log(that.userAppointmentSampleSumData);
							if (that.userAppointmentSampleSumData.length == 0) {
								that.userLaterSampleDtat = [];
								that.pagination.total = 0;
							}
							if (that.userID == '') {
								that.userID = that.userAppointmentSampleSumData[0].userId;
							}
							if (that.userID != '') {
								that.queryUserAppointmentSample(that.userID); //查询访员的稍后样本
							}
						}
					} else {
						that.userAppointmentSampleSumData = [];
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},
		userLaterSampleChange(val) {
			let tempUserLaterSample = [];
			val.forEach(item => {
				tempUserLaterSample.push(item.sampleId);
			});
			this.userLaterSampleSelect = tempUserLaterSample;
		},
		handleSizeChange(val) {
			this.pagination.pageSize = val;
			this.pagination.pageNo = 1;
			this.queryUserAppointmentSample(this.userId);
		},
		handleCurrentChange(val) {
			this.pagination.pageNo = val;
			this.queryUserAppointmentSample(this.userId);
		},
		queryUserAppointmentSample(userId) {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.queryUserAppointmentSample}`,
				method: 'POST',
				data: {
					qid: this.id,
					userId: userId,
					currentPage: this.pagination.pageNo,
					pageSize: this.pagination.pageSize,
					source:this.source
				},
				cb(res) {
					if (res.code == 0) {
						console.log(res);
						that.userLaterSampleDtat = res.resultBody.result;
						that.pagination.total = res.resultBody.totalCount;
					} else {
						that.userLaterSampleDtat = [];
						that.pagination.total = 0;
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},
		goback() {
			this.$router.go(-1)
		}
	}
};
</script>

<style scoped lang="scss">
.setBtn{
	padding: 0 20px;
	text-align: right;
}
.sampleAssignment {
	margin: 0px;
	padding: 0px;
	width: 100%;
	height: 100%;
	.details_header {
		// max-width: 1200px;
		height: 60px;
		line-height: 60px;
		text-align: center;
		background-color: #0080ff;
		margin: auto;
		display: flex;
		justify-content: space-between;
		span {
			// color: #333333;
			color: #fff;
			font-size: 16px;
			padding: 0px 30px;
		}
		margin-bottom: 20px;
		cursor: pointer;
	}
	.sampleAssignmentBox {
		width: 100%;
		.topTableBox {
			padding: 20px;
			display: flex;
			justify-content: space-between;
			.el-table {
				flex: none;
			}
			.topLeft {
				width: 240px;
				margin-right: 20px;
				.checkedTrue {
					cursor: pointer;
					color: #0080ff;
				}
				.checkedFalse {
					cursor: pointer;
				}
			}
			.topRight {
				width: calc(100% - 250px);
				flex: 1;
				.block {
					text-align: right;
					margin-top: 20px;
				}
			}
		}
		.botBox {
			padding: 20px;
		}
	}
}
</style>
